import { IRoute } from "@src/routes";
import ListFinancialReimbursement from "./pages/ListFinancialReimbursement";

import { SsoRolesEnum } from "@funcional/react-auth-ui";
import { ReadAndEditIndustryRulesPage } from "./pages/ReadAndEditFinancialRefund";

const routes: IRoute[] = [
  {
    path: "/refund/financial-reimbursement",
    key: "REFUND_FINANCIAL_REIMBURSEMENT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ListFinancialReimbursement,
  },
  {
    path: "/refund/financial-reimbursement/:action/:industryName",
    key: "REFUND_FINANCIAL_REIMBURSEMENT_READ",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ReadAndEditIndustryRulesPage,
  },
  {
    path: "/refund/financial-reimbursement/:action/:industryName",
    key: "REFUND_FINANCIAL_REIMBURSEMENT_EDIT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: ReadAndEditIndustryRulesPage,
  },
];

export default routes;
